@if ({
  pages: pages$ | async,
  pagination: pagination$ | async,
  isPristine: isPristine$ | async,
  }; as content) {
  <div class="page-grid-container">
    @if (!content.isPristine) {
      @if (component.line1) {
        <p class="h2 text-primary">{{ component.line1 }}</p>
      }
      @if (component.line2) {
        <p class="h4">{{ component.line2 }}</p>
      }
      @if (content.pages?.length) {
        <div class="pages-container">
          @for (page of content.pages; track page) {
            <div class="page-card simple-card" [ngStyle]="{ 'flex-basis': getFlexBasis() }">
              <a [routerLink]="page.label">
                <div class="box-image" [ngStyle]="{ 'background-image': 'url(' + page.previewImage?.url + ')' }"></div>
              </a>
              <a class="line-1" [routerLink]="page.label">
                {{ page.line1 }}
              </a>
              <div class="line-2" [innerHTML]="page.line2"></div>
            </div>
          }
        </div>
      } @else {
        <div class="no-results text-center ff-bold">
          <p>
            {{ 'generic.noContent' | cxTranslate }}
          </p>
        </div>
      }
    } @else {
      <local-loader></local-loader>
    }
  </div>
  @if (content.pagination) {
    <div class="d-flex justify-content-center w-100 m-t-20">
      <cx-pagination [pagination]="content.pagination" (viewPageEvent)="pageChange($event)"></cx-pagination>
    </div>
  }
}
